/* @flow */

import {MIN_SEARCH_LENGTH} from '../../consts';

import {FIELD_NAME, FIELD_ADDRESS, FIELD_DESCRIPTION} from './consts';
import {type AccountFormFieldTypes} from './types';

export const shouldShowPotentialAccounts = (
    name: ?string,
    description: ?string,
    address: ?string
) => {
    return (
        (name && name.length >= MIN_SEARCH_LENGTH) ||
        (description && description.length >= MIN_SEARCH_LENGTH) ||
        (address && address.length >= MIN_SEARCH_LENGTH)
    );
};

export const shouldAllowCreate = (isTemporary: boolean, name: ?string, address: ?string) => {
    return (
        !isTemporary &&
        ((name && name.length >= MIN_SEARCH_LENGTH) ||
            (address && address.length >= MIN_SEARCH_LENGTH))
    );
};

export const handleKeyboardNavigation = (
    e: SyntheticKeyboardEvent<>,
    currentField: AccountFormFieldTypes,
    addressRef: React.Ref<?HTMLInputElement | null>,
    descriptionRef: React.Ref<?HTMLInputElement | null>,
    nameRef: React.Ref<?HTMLInputElement | null>
) => {
    switch (e.key) {
        case 'ArrowDown':
            if (currentField === FIELD_NAME)
                descriptionRef.current && descriptionRef.current.focus();
            if (currentField === FIELD_DESCRIPTION)
                addressRef.current && addressRef.current.focus();
            if (currentField === FIELD_ADDRESS) nameRef.current && nameRef.current.focus();
            break;
        case 'ArrowUp':
            if (currentField === FIELD_NAME) addressRef.current && addressRef.current.focus();
            if (currentField === FIELD_DESCRIPTION) nameRef.current && nameRef.current.focus();
            if (currentField === FIELD_ADDRESS)
                descriptionRef.current && descriptionRef.current.focus();
            break;
    }
};
